export enum AppTrackEvent {
    AppDetailsOpened = 'AppDetailsOpened',
    AppPageOpened = 'AppPageOpened',
}
